module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "3pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "dedi"
    }
  }), _vm._v("This work is dedicated to the memory of the honorable Abdul Aziz former")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("Senior Advocate of the Supreme Court of Bangladesh")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("“Exemplary people understand things in terms of justice.”")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("—"), _c('i', [_vm._v("Analects of Confucius")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87f35d26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03dedication.vue
// module id = 63
// module chunks = 0